/**
 * Rule: a non-gateway flow node may have AT MOST ONE outgoing sequence flow.
 *
 * Only a Gateway is allowed to branch (>1 outgoing). A StartEvent, a Task /
 * UserTask / SubProcess / CallActivity, or an intermediate event with two or
 * more outgoing sequence flows is an uncontrolled (implicit) split — forbidden
 * by Kuika's contract ("Task/Step: EXACTLY 1 outgoing. Branch = Gateway").
 *
 * The DSL parse-time validator (`non-gateway-single-outgoing`) only sees a
 * single script's alias graph, so it misses a second outgoing added across
 * scripts or via CONNECT/PATH from a pre-existing real ID — e.g. inserting a
 * gateway with `after:StartEvent_1` (START -> gateway) and then later wiring
 * `CONNECT START -> SampleStep`, leaving START with two outgoing arrows
 * (KOA-17362). This runtime rule catches the multi-outgoing however it arose.
 *
 * Exemptions: Gateways (branching is their job), EndEvents (no outgoing), and
 * BoundaryEvents (a boundary's single outgoing is its escalation path, and the
 * boundary is NOT counted as an outgoing of its host).
 */
const { is } = require("bpmnlint-utils");

module.exports = function singleOutgoingNonGateway() {
  return {
    check(node, reporter) {
      if (!node || !is(node, "bpmn:FlowNode")) {
        return;
      }
      // Gateways are the only elements allowed to branch.
      if (is(node, "bpmn:Gateway")) {
        return;
      }
      // End events have no outgoing; boundary events carry one by design.
      if (is(node, "bpmn:EndEvent")) {
        return;
      }
      const bo = node.businessObject || node;
      if (bo.$type === "bpmn:BoundaryEvent") {
        return;
      }

      const outgoing = Array.isArray(node.outgoing) ? node.outgoing : [];
      const sequenceFlows = outgoing.filter((flow) => is(flow, "bpmn:SequenceFlow"));

      if (sequenceFlows.length > 1) {
        reporter.report(
          node.id,
          "This element has more than one outgoing connection. Only a Gateway may branch — a task, step, or event must have exactly one outgoing flow. Route the branches through a Gateway, or remove the extra connection."
        );
      }
    }
  };
};
